module.exports = __webpack_public_path__ + "static/media/profile_background.5ccbb4f2.png";